/* eslint-disable */
(() => {
  // disables script as Piwik is being hit hard
  return;
  const init = function init() {
    const jsonLd = document.querySelector('[type="application/ld+json"]');
    if (
      !jsonLd
      || jsonLd.innerText.indexOf('"Product"') === -1
    ) {
      // Not a product page: exit
      return;
    }

    // Breadcrumb
    window.swinger.observer.initialize('.swinger-breadcrumb', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Hero – Breadcrumb');
    }, false);
    window.swinger.observer.initialize('.swinger-breadcrumb a', (elem) => {
      elem.setAttribute('data-content-piece', 'Link');
    }, false);

    // Bewertungen
    window.swinger.observer.initialize('.swinger-stars-meter', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Hero – Rating Stars');
    }, false);
    window.swinger.observer.initialize('.swinger-stars-meter__meter', (elem) => {
      elem.setAttribute('data-content-piece', 'Rating Stars');
    }, false);

    // Studio Logo
    window.swinger.observer.initialize('.swinger-studio-box a', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Tabs – Studio-Logo');
    }, false);
    window.swinger.observer.initialize('.swinger-studio-box a img', (elem) => {
      elem.setAttribute('data-content-piece', 'Image');
    }, false);

    window.swinger.observer.initialize('.swinger-image--cover', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Hero – Cover');
    }, false);
    window.swinger.observer.initialize('.swinger-image--cover img', (elem) => {
      elem.setAttribute('data-content-piece', 'Image');
    }, false);

    // Szenen Galerien
    window.swinger.observer.initialize('.swinger-gallery', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Scenes – Gallery');
      elem.setAttribute('data-content-target', 'Gallery');
    }, false);
    window.swinger.observer.initialize('.swinger-gallery img', (elem) => {
      elem.setAttribute('data-content-piece', 'Image');
    }, false);

    // Film Galerie
    window.swinger.observer.initialize('.swinger-slider-gallery', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Movie – Gallery');
      elem.setAttribute('data-content-target', 'Gallery');
    }, false);
    window.swinger.observer.initialize('.swinger-slider-gallery img', (elem) => {
      elem.setAttribute('data-content-piece', 'Image');
    }, false);

    // Registrierung
    window.swinger.observer.initialize('.swinger-cta-register', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Registration Overlay – Register');
    }, false);
    window.swinger.observer.initialize('.swinger-cta-register__button a', (elem) => {
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // Movie Box Area
    window.swinger.observer.initialize('.swinger-movie-box', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Bottom Area – Movie Box');
    }, false);

    // Trailer Abspielen
    window.swinger.observer.initialize('.swinger-video-player[data-type="trailer"]', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Hero – Trailer');
    }, false);
    window.swinger.observer.initialize('.swinger-video-player[data-type="trailer"] .plyr__control', (elem) => {
      elem.setAttribute('data-content-piece', 'Player Icon');
    }, false);

    // Merkliste
    window.swinger.observer.initialize('.swinger-button-like', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Merkliste');
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // Film Kaufen
    window.swinger.observer.initialize('.swinger-button-purchase[data-type="movie"][data-transaction-type="buy"] button', (elem) => {
      const contentName = window.swinger.config.client === 'erotik' ? 'PDP – Buy Area – Film Download kaufen' : 'PDP – Buy Area – Film DVD kaufen';
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', contentName);
      elem.setAttribute('data-content-target', 'Checkout');
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // Szene Kaufen
    window.swinger.observer.initialize('.swinger-button-purchase[data-type="scene"][data-transaction-type="buy"] button', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Buy Area – Szenen Download kaufen');
      elem.setAttribute('data-content-target', 'Checkout');
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // Film Leihen
    window.swinger.observer.initialize('.swinger-button-purchase[data-type="movie"][data-transaction-type="rent"] button', (elem) => {
      elem.setAttribute('data-content-piece', 'Button');
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Buy Area – Film Download ausleihen');
      elem.setAttribute('data-content-target', 'Checkout');
    }, false);

    // Szene Leihen
    window.swinger.observer.initialize('.swinger-button-purchase[data-type="scene"][data-transaction-type="rent"] button', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Buy Area – Szenen Download ausleihen');
      elem.setAttribute('data-content-target', 'Checkout');
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // zu (DVD)Erotik.com
    window.swinger.observer.initialize('.swinger-button swinger-hero__button-other', (elem) => {
      const contentName = window.swinger.config.client === 'erotik' ? 'PDP – Buy Area – Zu DVDEROTIK.COM' : 'PDP – Buy Area – Zu EROTIK.COM';
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', contentName);
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // Kategorien
    window.swinger.observer.initialize('.swinger-tags', (elem) => {
      const contentName = elem.closest('.swinger-hero') ? 'PDP – Hero – Kategorien' : 'PDP – Infos – Kategorien';
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', contentName);
    }, false);
    window.swinger.observer.initialize('.swinger-tags a', (elem) => {
      elem.setAttribute('data-content-piece', 'Link');
    }, false);
    window.swinger.observer.initialize('.swinger-tags button', (elem) => {
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // Darsteller
    window.swinger.observer.initialize('.swinger-slider[aria-label*="stars"]', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Performers – Gallery');
    }, false);
    window.swinger.observer.initialize('.swinger-slider[aria-label*="stars"] img', (elem) => {
      elem.setAttribute('data-content-piece', 'Image');
    }, false);

    // Darsteller Avatare
    window.swinger.observer.initialize('[class$="box__performers"]', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Infos – Performers');
    }, false);
    window.swinger.observer.initialize('[class$="box__performers"] a', (elem) => {
      elem.setAttribute('data-content-piece', 'Link');
    }, false);
    window.swinger.observer.initialize('[class$="box__performers"] button', (elem) => {
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // Tabs
    window.swinger.observer.initialize('.swinger-tabs__tablist', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Tabs');
    }, false);
    window.swinger.observer.initialize('.swinger-tabs__tablist-link', (elem) => {
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // Movie Details
    window.swinger.observer.initialize('.swinger-media-details', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Movie Details');
    }, false);

    // Specs Area
    window.swinger.observer.initialize('.swinger-media-details__metadata', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Specs Area');
    }, false);

    // Bewertung schreiben Knopf
    window.swinger.observer.initialize('.swinger-button-rate', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Infos - Write Review');
      elem.setAttribute('data-content-piece', 'Button');
    }, false);

    // Ähnliche Filme
    window.swinger.observer.initialize('.swinger-widget--recommendations .swinger-slider--card-movie', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Bottom Area – Similar Movies');
    }, false);
    window.swinger.observer.initialize('.swinger-widget--recommendations .swinger-slider--card-movie img', (elem) => {
      elem.setAttribute('data-content-piece', 'Image');
    }, false);

    // Ähnliche Szenen
    window.swinger.observer.initialize('.swinger-widget--recommendations .swinger-slider--card-scene', (elem) => {
      elem.setAttribute('data-track-content', '');
      elem.setAttribute('data-content-name', 'PDP – Bottom Area – Similar Scenes');
    }, false);
    window.swinger.observer.initialize('.swinger-widget--recommendations .swinger-slider--card-scene img', (elem) => {
      elem.setAttribute('data-content-piece', 'Image');
    }, false);
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
